<div class="breadcrumb-wrapper">
    <div class="container">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" [routerLink]="['/home']">{{'HEADER.Home' | translate}}</li>
                <i class="fa fa-angle-right" style="padding: 8px; margin-top: -3px"></i>
                <li class="breadcrumb-item" [routerLink]="['/profile']">{{'ACCOUNT.YOUR_PROFILE' | translate}}
                </li>
            </ol>
        </nav>
    </div>
</div>

<div class="container">
    <div class="row">
      <div class="card mt-3 tab-card">
        <div class="card-header tab-card-header">
          <ul class="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a [routerLinkActive]="['active']" class="nav-link fade show active" id="one-tab" data-toggle="tab" href="#one" role="tab"
              aria-controls="One" aria-selected="true">{{'ACCOUNT.YOUR_ORDERS' | translate}}</a>
            </li>
            <li class="nav-item">
              <a [routerLinkActive]="['active']"class="nav-link" id="two-tab" data-toggle="tab" href="#two"  role="tab"
              aria-controls="Two" aria-selected="false">{{'ACCOUNT.YOUR_PROFILE' | translate}}</a>
            </li>
          </ul>
        </div>

        <div class="tab-content" id="myTabContent">
                 <!-- My Cources Details -->
        <div class="tab-pane fade show active p-3" id="one" role="tabpanel" aria-labelledby="one-tab">
          <div class="row m-4">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>{{'ACCOUNT.ORDERS.MY_ORDERS' | translate}}</th>
                  <th>{{'ACCOUNT.ORDERS.DATE' | translate}}</th>
                  <th>{{'ACCOUNT.ORDERS.STATUS' | translate}}</th>
                  <th>{{'ACCOUNT.ORDERS.TOTAL_AMOUNT' | translate}}</th>
                  <th>{{'ACCOUNT.ORDERS.DETAILS' | translate}}</th>
                </tr>
              </thead>
              <tbody *ngFor="let order of orderList">
                <tr>
                  <td>{{order?.orderNumber}}</td>
                  <td>{{order?.orderDate|  date: 'dd/MM/yyyy'}}</td>
                  <td>{{order?.orderStatusStr}}</td>
                  <td>{{order?.totalAmount}}</td>
                  <td >
                    <a class="view-details" [routerLink]="['/orderdetail', order?.id]">{{'ACCOUNT.ORDERS.VIEW_DETAILS' | translate}}</a>
                </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row m-4" *ngIf="orderList.length === 0">
            <h4>
              No Order Found...!</h4>
            </div>


        </div>
          <!-- My Profile Details -->
          <div class="tab-pane fade p-3" id="two" role="tabpanel" aria-labelledby="two-tab">
            <table class="table table-hover">
                <thead>
                  <tr>
                    <th> {{'ACCOUNT.ORDERS.MY_NAME' | translate}}</th>
                    <th> {{'ACCOUNT.ORDERS.MY_EMAIL' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{userInfo?.firstName}} {{userInfo?.lastName}}</td>
                    <td>{{userInfo?.mobile}}{{userInfo?.email}}</td>
                  </tr>
                </tbody>
              </table>
              <app-address [fromAccont]="true"></app-address>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br><br>